@if (showLabel()) {
  <div class="fx--h fx--label fx--label__nowrap fx--mb-4 fx--label__bold fx--juc-space-between">
    <label class="miq-form-input-label" [attr.for]="filter$().key">{{ filter$().value }}</label>
  </div>
}
@switch (filter$().inputType) {
  <!-- DATES -->
  @case ('date') {
    <div class="fx--h filters__gap">
      <mat-form-field appearance="outline">
        <input
          matInput
          readonly
          autocomplete="no-autofill"
          [formControl]="fromCtrl"
          [matDatepicker]="fromRangeDatePicker"
          placeholder="FROM"
          (dateChange)="dateEvent('from', $event)"
          [max]="filter$().maxValue"
          />
          <mat-datepicker-toggle matSuffix [for]="fromRangeDatePicker"></mat-datepicker-toggle>
          @if (filter$().inputType === 'date' && hasFromCtrlValue) {
            <em
              class="value-clear pi pi-times-circle filters-date-picker-clear"
              (click)="clearRangeFilter('from')"
            ></em>
          }
          <mat-datepicker #fromRangeDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input
            matInput
            autocomplete="no-autofill"
            readonly
            [formControl]="toCtrl"
            [matDatepicker]="toRangeDatePicker"
            placeholder="TO"
            (dateChange)="dateEvent('to', $event)"
            [min]="filter$().minValue"
            />
            <mat-datepicker-toggle matSuffix [for]="toRangeDatePicker"></mat-datepicker-toggle>
            @if (filter$().inputType === 'date' && hasToCtrlValue) {
              <em
                class="value-clear pi pi-times-circle filters-date-picker-clear"
                (click)="clearRangeFilter('to')"
              ></em>
            }
            <mat-datepicker #toRangeDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      }
      <!-- For filters with dataType as numeric or integer -->
      @case ('number') {
        <div class="fx--h">
          <mat-form-field floatLabel="never" appearance="outline">
            <input
              matInput
              miqOnlyNumbers
              [restrictedKeyCodes]="restrictedKeyCodes"
              [allowedKeyCodes]="allowedKeyCodes"
              [readonly]="fromCtrl?.disabled"
              autocomplete="no-autofill"
              placeholder="FROM"
              [formControl]="fromCtrl"
              [type]="filter$().inputType"
              (keydown.enter)="updateForm($event, 'from')"
            /></mat-form-field>
            <mat-form-field floatLabel="never" appearance="outline">
              <input
                matInput
                miqOnlyNumbers
                [restrictedKeyCodes]="restrictedKeyCodes"
                [allowedKeyCodes]="allowedKeyCodes"
                [readonly]="toCtrl?.disabled"
                [type]="filter$().inputType"
                placeholder="TO"
                autocomplete="no-autofill"
                [formControl]="toCtrl"
              /></mat-form-field>
            </div>
          }
          <!-- ALL OTHERS, for example where inputType = text -->
          @default {
            <div class="fx--h">
              <mat-form-field floatLabel="never" appearance="outline">
                <input
                  matInput
                  [readonly]="fromCtrl?.disabled"
                  autocomplete="no-autofill"
                  placeholder="FROM"
                  [formControl]="fromCtrl"
                  [type]="filter$().inputType"
                  (keydown.enter)="updateForm($event, 'from')"
                /></mat-form-field>
                <mat-form-field floatLabel="never" appearance="outline">
                  <input
                    matInput
                    [readonly]="toCtrl?.disabled"
                    autocomplete="no-autofill"
                    placeholder="TO"
                    [formControl]="toCtrl"
                    [type]="filter$().inputType"
                    (keydown.enter)="updateForm($event, 'to')"
                  /></mat-form-field>
                </div>
              }
            }
